export const COMPANY = {
  name: "Clocktower Cars Gatwick",
  shortName: "Clocktower Cars",
  phone: "01293 515151",
  phoneRaw: "+441293515151",
  whatsapp: "441372747747",
  email: "bookings@clocktowercarsuk.com",
  tagline: "Gatwick's Premier Private Hire & Airport Transfers",
  welcome: "Whether you are travelling for business, a family holiday or a special occasion, Clocktower Cars provides professional chauffeur-driven airport transfers with punctual service, luxury vehicles and experienced local drivers available 24 hours a day.",
  address: "Churchill Court, Crawley RH10 9KU, United Kingdom",
  postcodes: "RH10 & RH11",
  reviews: "774",
  fares: { gatwick: "£25", heathrow: "£45" },
  bookingUrl: "https://www.epsomcars-online.com/webbookerconsumer/#/booking",
};

export const BOOKING_URL = "https://www.epsomcars-online.com/webbookerconsumer/#/booking";

export const VEHICLE_TYPES = [
  { value: "Saloon", label: "Saloon — up to 4 passengers" },
  { value: "MPV Medium", label: "MPV Medium — up to 5 passengers" },
  { value: "MPV Large", label: "MPV Large — up to 6 passengers" },
  { value: "Executive", label: "Executive — up to 3 passengers" },
  { value: "Wheelchair", label: "Wheelchair Accessible — ramp equipped" },
  { value: "Minibus", label: "Minibus — up to 16 passengers" },
];

export const FLEET = [
  {
    slug: "saloon",
    name: "Saloon",
    tier: "Standard",
    desc: "Brand-new 2026 executive saloon — the everyday choice for airport runs and local journeys. Comfortable, immaculate and fully valeted.",
    seats: 4,
    luggage: 2,
    image: "/images/fleet/saloon.jpg",
    gallery: [
      { src: "/images/fleet/saloon.jpg", alt: "Saloon exterior — Mercedes E-Class", caption: "Exterior" },
      { src: "/images/services/chauffeur.jpg", alt: "Saloon interior with professional chauffeur", caption: "Chauffeur & interior" },
      { src: "/images/services/airport.jpg", alt: "Saloon boot with airport luggage loaded", caption: "Airport-ready boot" },
    ],
    tagline: "The everyday choice for airport transfers and local journeys",
    model: "Mercedes E-Class / Volkswagen Passat / Skoda Superb (or similar)",
    year: "2026",
    features: [
      "Air-conditioned climate control",
      "Complimentary bottled water",
      "USB charging & Wi-Fi on request",
      "Card, Apple Pay & Google Pay accepted",
      "Free 45-min meet & greet on arrivals",
      "Child seat available on request",
    ],
    perfectFor: [
      "Solo travellers and couples heading to Gatwick or Heathrow",
      "Business commuters and daily airport runs",
      "Local Crawley, Horley and Surrey journeys",
      "Meetings around Manor Royal and the Gatwick Diamond",
    ],
    specs: [
      { label: "Passengers", value: "Up to 4" },
      { label: "Luggage", value: "2 large + 2 cabin" },
      { label: "Doors", value: "4" },
      { label: "Class", value: "Standard executive saloon" },
    ],
  },
  {
    slug: "mpv-medium",
    name: "MPV Medium",
    tier: "People Carrier",
    desc: "A brand-new 2026 medium people carrier with room for five and extra luggage — ideal for small families and groups heading to Gatwick.",
    seats: 5,
    luggage: 4,
    image: "/images/fleet/mpv-medium.jpg",
    gallery: [
      { src: "/images/fleet/mpv-medium.jpg", alt: "Medium MPV exterior", caption: "Exterior" },
      { src: "/images/services/local.jpg", alt: "Medium MPV interior sliding-door access", caption: "Sliding-door access" },
      { src: "/images/services/event.jpg", alt: "Medium MPV loaded for family event", caption: "Family-ready boot" },
    ],
    tagline: "Extra room for small families and larger luggage loads",
    model: "Ford Galaxy / SEAT Alhambra / Volkswagen Sharan (or similar)",
    year: "2026",
    features: [
      "Sliding doors for easy access",
      "Individual reclining seats",
      "Climate control throughout",
      "USB charging in every row",
      "Child seat & booster available",
      "Card, Apple Pay & Google Pay accepted",
    ],
    perfectFor: [
      "Families of 4 or 5 with airport luggage",
      "Small groups heading to weddings or events",
      "Days out with buggies, sports kit or golf clubs",
      "Comfortable local runs when a saloon isn't enough",
    ],
    specs: [
      { label: "Passengers", value: "Up to 5" },
      { label: "Luggage", value: "4 large + hand luggage" },
      { label: "Doors", value: "5 (sliding rear)" },
      { label: "Class", value: "Medium people carrier" },
    ],
  },
  {
    slug: "mpv-large",
    name: "MPV Large",
    tier: "People Carrier",
    desc: "The latest 2026 large luxury MPV — spacious seating for six with generous boot space for suitcases, pushchairs and golf clubs.",
    seats: 6,
    luggage: 6,
    image: "/images/fleet/mpv-large.jpg",
    gallery: [
      { src: "/images/fleet/mpv-large.jpg", alt: "V-Class exterior", caption: "Exterior" },
      { src: "/images/services/corporate.jpg", alt: "V-Class panoramic passenger cabin", caption: "Six-seat cabin" },
      { src: "/images/hero/clocktower-car.jpg", alt: "V-Class ready for airport transfer", caption: "Airport-ready" },
    ],
    tagline: "Six seats and serious boot space — the family favourite",
    model: "Mercedes V-Class / Volkswagen Multivan (or similar)",
    year: "2026",
    features: [
      "Six individual leather seats",
      "Panoramic windows and tinted rear glass",
      "Climate control zones",
      "USB & 12V charging throughout",
      "Optional table configuration on request",
      "Free 60-min meet & greet on arrivals",
    ],
    perfectFor: [
      "Families of 5 or 6 with full airport luggage",
      "Group trips, ski holidays and long-distance journeys",
      "Weddings, hen parties and evening events",
      "Corporate group transfers between London and Gatwick",
    ],
    specs: [
      { label: "Passengers", value: "Up to 6" },
      { label: "Luggage", value: "6 large + hand luggage" },
      { label: "Doors", value: "5 (sliding rear)" },
      { label: "Class", value: "Large luxury MPV" },
    ],
  },
  {
    slug: "executive",
    name: "Executive",
    tier: "First Class",
    desc: "A brand-new 2026 executive limousine with white-glove chauffeur service — the ultimate in comfort and prestige for business and VIP travel.",
    seats: 3,
    luggage: 3,
    image: "/images/fleet/executive.jpg",
    gallery: [
      { src: "/images/fleet/executive.jpg", alt: "Executive S-Class exterior", caption: "Exterior" },
      { src: "/images/firstclass.jpg", alt: "Executive interior with rear reclining seats", caption: "First-class interior" },
      { src: "/images/services/chauffeur.jpg", alt: "Executive chauffeur with name-board meet & greet", caption: "Chauffeur meet & greet" },
    ],
    tagline: "First-class travel with a professional chauffeur",
    model: "Mercedes S-Class / BMW 7 Series (or similar)",
    year: "2026",
    features: [
      "Full leather interior and rear reclining seats",
      "In-car Wi-Fi and premium sound system",
      "Complimentary bottled water and newspapers on request",
      "Tinted rear windows for privacy",
      "Suited, DBS-checked chauffeur",
      "Personal name-board meet & greet included",
    ],
    perfectFor: [
      "C-suite executives and VIP airport transfers",
      "Corporate roadshows and client pick-ups",
      "Weddings and special occasions requiring quiet luxury",
      "Discreet, chauffeur-driven London and Gatwick travel",
    ],
    specs: [
      { label: "Passengers", value: "Up to 3" },
      { label: "Luggage", value: "3 large + hand luggage" },
      { label: "Doors", value: "4" },
      { label: "Class", value: "Luxury executive saloon" },
    ],
  },
  {
    slug: "wheelchair",
    name: "Wheelchair",
    tier: "Accessible",
    desc: "A 2026 wheelchair-accessible vehicle with a rear access ramp and secure restraints — safe, dignified travel for a wheelchair user plus up to three passengers.",
    seats: 4,
    luggage: 2,
    image: "/images/fleet/wheelchair.jpg",
    gallery: [
      { src: "/images/fleet/wheelchair.jpg", alt: "Wheelchair-accessible vehicle exterior", caption: "Exterior" },
      { src: "/images/services/wheelchair.jpg", alt: "Rear ramp and secure wheelchair restraints", caption: "Rear ramp access" },
      { src: "/images/services/local.jpg", alt: "Accessible taxi ready for a local journey", caption: "Local journeys" },
    ],
    tagline: "Safe, dignified accessible travel for every journey",
    model: "Peugeot Rifter / Ford Tourneo (accessible conversion)",
    year: "2026",
    features: [
      "Rear-access ramp and low-floor entry",
      "Four-point secure wheelchair restraints",
      "Trained accessible-transport driver",
      "Room for one wheelchair + 3 passengers",
      "Advance booking recommended",
      "Enhanced DBS-checked driver",
    ],
    perfectFor: [
      "Hospital and medical appointments",
      "Accessible Gatwick and Heathrow transfers",
      "Local journeys for wheelchair users and carers",
      "Day trips, family visits and social outings",
    ],
    specs: [
      { label: "Passengers", value: "1 wheelchair + 3 seated" },
      { label: "Luggage", value: "2 medium" },
      { label: "Access", value: "Rear ramp, low floor" },
      { label: "Class", value: "Wheelchair-accessible" },
    ],
  },
  {
    slug: "minibus",
    name: "Minibus",
    tier: "Group Travel",
    desc: "A brand-new 2026 16-seat luxury minibus for larger parties, corporate groups and special events — travel together in comfort and style.",
    seats: 16,
    luggage: 16,
    image: "/images/fleet/minibus.jpg",
    gallery: [
      { src: "/images/fleet/minibus.jpg", alt: "16-seat minibus exterior", caption: "Exterior" },
      { src: "/images/services/event.jpg", alt: "Minibus interior with coach seating and belts", caption: "16 forward-facing seats" },
      { src: "/images/services/school.jpg", alt: "Minibus loaded for a group event", caption: "Group-ready boot" },
    ],
    tagline: "Sixteen seats — the whole party travels together",
    model: "Mercedes Sprinter / Ford Transit (16-seat coach conversion)",
    year: "2026",
    features: [
      "16 forward-facing coach seats with belts",
      "Large boot area for suitcases and kit bags",
      "Air-conditioned throughout",
      "PCV-licensed and PSV-insured driver",
      "Overhead storage and reading lights",
      "Ideal for weddings, corporate groups and sport",
    ],
    perfectFor: [
      "Corporate group transfers to Gatwick and Heathrow",
      "Weddings, stag and hen weekends",
      "Sports teams and club outings",
      "Conference and event shuttle work",
    ],
    specs: [
      { label: "Passengers", value: "Up to 16" },
      { label: "Luggage", value: "16 large + kit bags" },
      { label: "Doors", value: "Side + rear boot" },
      { label: "Class", value: "16-seat luxury coach" },
    ],
  },
];

const airports = (gT, gP, hT, hP) => [
  { name: "Gatwick", time: gT, price: gP },
  { name: "Heathrow", time: hT, price: hP },
];

export const AREAS = [
  { slug: "crawley", name: "Crawley", tagline: "Crawley's trusted 24/7 taxi service", image: "/images/services/airport.jpg", landmarks: ["County Mall", "Crawley Station", "K2 Crawley", "Hawth Theatre", "Manor Royal"], airports: airports("10 mins", "£25", "50 mins", "£75") },
  { slug: "horley", name: "Horley", tagline: "Fast airport transfers from Horley", image: "/images/services/chauffeur.jpg", landmarks: ["Horley Station", "Horley Town Centre", "Gatwick Airport", "Riverside Garden Park", "Collendean"], airports: airports("8 mins", "£25", "45 mins", "£72") },
  { slug: "charlwood", name: "Charlwood", tagline: "Village taxis serving Charlwood & Hookwood", image: "/images/hero/clocktower-car.jpg", landmarks: ["St Nicholas Church", "The Half Moon", "Gatwick Aviation Museum", "Hookwood", "Russ Hill"], airports: airports("10 mins", "£25", "45 mins", "£72") },
  { slug: "copthorne", name: "Copthorne", tagline: "Reliable private hire in Copthorne", image: "/images/services/corporate.jpg", landmarks: ["Copthorne Common", "Effingham Park", "Copthorne Hotel", "St John's Church", "Snow Hill"], airports: airports("12 mins", "£26", "55 mins", "£80") },
  { slug: "maidenbower", name: "Maidenbower", tagline: "Door-to-door cabs across Maidenbower", image: "/images/services/local.jpg", landmarks: ["Maidenbower Square", "Maidenbower Park", "Worth Park", "Crawley Down Road", "Tilgate Forest"], airports: airports("12 mins", "£25", "55 mins", "£78") },
  { slug: "furnace-green", name: "Furnace Green", tagline: "Local taxis in Furnace Green", image: "/images/services/local.jpg", landmarks: ["Tilgate Park", "Furnace Green Shops", "Tilgate Nature Centre", "The Lake", "Southgate"], airports: airports("12 mins", "£25", "50 mins", "£75") },
  { slug: "langley-green", name: "Langley Green", tagline: "Quick pickups in Langley Green", image: "/images/services/airport.jpg", landmarks: ["Langley Green Station", "Cheals Roundabout", "Manor Royal", "Gatwick North", "Ifield"], airports: airports("10 mins", "£25", "50 mins", "£75") },
  { slug: "gossops-green", name: "Gossops Green", tagline: "Gossops Green's friendly cab firm", image: "/images/services/local.jpg", landmarks: ["Gossops Green Parade", "Ifield Golf Club", "Bewbush Water Gardens", "Ifield Station", "Dobbins Pond"], airports: airports("12 mins", "£25", "50 mins", "£75") },
  { slug: "broadfield", name: "Broadfield", tagline: "Broadfield taxis, day or night", image: "/images/services/event.jpg", landmarks: ["Broadfield Stadium", "Broadfield Barton", "K2 Leisure Centre", "Tilgate", "Bewbush"], airports: airports("14 mins", "£26", "55 mins", "£78") },
  { slug: "bewbush", name: "Bewbush", tagline: "Bewbush's dependable private hire", image: "/images/services/school.jpg", landmarks: ["Bewbush Water Gardens", "Breezehurst Drive", "Kilnwood Vale", "Ifield West", "Broadfield"], airports: airports("15 mins", "£27", "55 mins", "£78") },
  { slug: "east-grinstead", name: "East Grinstead", tagline: "Premium transfers from East Grinstead", image: "/images/services/chauffeur.jpg", landmarks: ["East Grinstead Station", "Chequer Mead", "Sackville College", "Standen House", "The Bluebell Railway"], airports: airports("20 mins", "£30", "60 mins", "£90") },
  { slug: "horsham", name: "Horsham", tagline: "Horsham to Gatwick, stress-free", image: "/images/services/corporate.jpg", landmarks: ["Horsham Station", "The Carfax", "Horsham Park", "Capitol Theatre", "Swan Walk"], airports: airports("25 mins", "£38", "55 mins", "£85") },
  { slug: "reigate", name: "Reigate", tagline: "Executive travel from Reigate", image: "/images/services/chauffeur.jpg", landmarks: ["Reigate Hill", "Priory Park", "Reigate Station", "Reigate Castle Grounds", "Redhill Aerodrome"], airports: airports("18 mins", "£28", "45 mins", "£75") },
  { slug: "redhill", name: "Redhill", tagline: "Redhill's round-the-clock taxis", image: "/images/services/corporate.jpg", landmarks: ["Redhill Station", "The Belfry Shopping", "East Surrey Hospital", "Memorial Park", "Redhill Aerodrome"], airports: airports("15 mins", "£25", "45 mins", "£72") },
  { slug: "haywards-heath", name: "Haywards Heath", tagline: "Comfortable rides from Haywards Heath", image: "/images/services/chauffeur.jpg", landmarks: ["Haywards Heath Station", "The Broadway", "Victoria Park", "Princess Royal Hospital", "Lindfield"], airports: airports("25 mins", "£40", "70 mins", "£95") },
  { slug: "three-bridges", name: "Three Bridges", tagline: "Three Bridges taxis & station transfers", image: "/images/services/airport.jpg", landmarks: ["Three Bridges Station", "County Mall", "Crawley Leisure Park", "Manor Royal", "Pound Hill"], airports: airports("8 mins", "£25", "50 mins", "£75") },
  { slug: "pound-hill", name: "Pound Hill", tagline: "Reliable cabs across Pound Hill", image: "/images/services/local.jpg", landmarks: ["Pound Hill Parade", "Worth Park", "Three Bridges Station", "Maidenbower", "Worth Abbey"], airports: airports("10 mins", "£25", "52 mins", "£76") },
  { slug: "tilgate", name: "Tilgate", tagline: "Local taxis serving Tilgate", image: "/images/services/event.jpg", landmarks: ["Tilgate Park", "Tilgate Nature Centre", "K2 Crawley", "Tilgate Forest", "Broadfield Stadium"], airports: airports("12 mins", "£25", "52 mins", "£76") },
  { slug: "ifield", name: "Ifield", tagline: "Ifield's friendly private hire", image: "/images/services/local.jpg", landmarks: ["Ifield Station", "Ifield Golf Club", "Ifield Mill Pond", "Gossops Green", "Bewbush"], airports: airports("12 mins", "£25", "52 mins", "£76") },
  { slug: "crawley-down", name: "Crawley Down", tagline: "Village taxis for Crawley Down", image: "/images/hero/clocktower-car.jpg", landmarks: ["Crawley Down Village", "Grange Road", "Turners Hill", "Copthorne", "Worth"], airports: airports("14 mins", "£27", "55 mins", "£80") },
].map((a) => ({
  ...a,
  intro: `Book a fast, safe and fully licensed taxi from ${a.name} with Clocktower Cars Gatwick. We run 24/7 with fixed-price airport transfers to Gatwick and Heathrow, plus reliable local journeys, executive travel and group bookings. Local drivers, spotless vehicles and no hidden charges.`,
}));

export const TESTIMONIALS = [
  { name: "Sarah M.", area: "Crawley", text: "Booked a 4am Gatwick run and the driver was early, immaculate S-Class and so friendly. My go-to now." },
  { name: "James P.", area: "Horley", text: "Use Clocktower for every airport trip. Flight was delayed but they tracked it and were waiting. Faultless." },
  { name: "Priya K.", area: "Reigate", text: "The V-Class for our family of six with all the luggage was perfect. Spacious, clean and on time." },
  { name: "Tom R.", area: "East Grinstead", text: "8-seater for a stag do — great value, punctual and got us home safely. Brilliant service." },
];

export const SERVICES = [
  { title: "Airport Transfer", desc: "Gatwick, Heathrow, Luton, London City & Stansted transfers with live flight tracking and fixed rates from Crawley and local towns.", icon: "Plane", img: "/images/services/airport.jpg" },
  { title: "Executive Corporate", desc: "Professional, discreet corporate taxis for meetings, events and daily commutes across Crawley, Surrey and Gatwick.", icon: "Briefcase", img: "/images/services/corporate.jpg" },
  { title: "Local Taxi Transfer", desc: "Reliable local taxis across Crawley — fast pick-ups, set fares and drivers with genuine local knowledge (RH10 & RH11).", icon: "MapPin", img: "/images/services/local.jpg" },
  { title: "Pet Friendly Taxi", desc: "Travel with your dog, cat or pets safely in secure, comfortable vehicles with caring drivers. Advance booking recommended.", icon: "PawPrint", img: "/images/services/pet.jpg" },
  { title: "Wheelchair Taxi", desc: "Wheelchair-accessible taxis with trained drivers, ramps and secure seating for appointments or accessible Gatwick transfers.", icon: "Accessibility", img: "/images/services/wheelchair.jpg" },
  { title: "Event Transfer", desc: "Transfers for weddings, parties, sports and nights out. Groups welcome across Crawley, Surrey and West Sussex.", icon: "PartyPopper", img: "/images/services/event.jpg" },
  { title: "School Run", desc: "Safe school runs for Crawley families — trusted drivers, approved routes and punctual drop-off and pick-up across RH10 & RH11.", icon: "GraduationCap", img: "/images/services/school.jpg" },
  { title: "Courier Service", desc: "Express same-day courier for packages, documents and parcels. Time-critical local and long-distance transport.", icon: "Package", img: "/images/services/courier.jpg" },
  { title: "Chauffeur Service", desc: "Executive chauffeur service for VIPs, events and corporate needs — luxury Mercedes vehicles and smart, professional drivers.", icon: "Crown", img: "/images/services/chauffeur.jpg" },
];

export const WHY_CHOOSE = [
  { title: "Local Expertise & Knowledge", desc: "Our drivers know every shortcut and main road in Crawley, Horley, Charlwood and Copthorne, planning the quickest, safest route using live traffic updates.", icon: "MapPin" },
  { title: "24/7 Availability & Reliability", desc: "Book any time, day or night. Fast response, on-time pick-ups and real-time updates make us Crawley's most dependable cab service.", icon: "Clock" },
  { title: "Professional, Vetted Drivers", desc: "Every driver is licensed, DBS-checked and trained for courteous service — helping with luggage and keeping every rider safe and comfortable.", icon: "ShieldCheck" },
  { title: "Modern, Maintained Vehicles", desc: "Travel in clean, regularly-serviced Mercedes — saloons, MPVs and executive options for every occasion, always ready inside and out.", icon: "Car" },
  { title: "Transparent Fixed Pricing", desc: "No meter surprises and no hidden charges. Know your fare before you travel for every Crawley or airport journey — quoted online or by phone.", icon: "PoundSterling" },
  { title: "Easy Booking & Technology", desc: "Book online or call our 24/7 team. Get instant confirmation, driver and vehicle details, and real-time tracking until pick-up.", icon: "Smartphone" },
];

export const STATS = [
  { value: "774+", label: "Google reviews" },
  { value: "4.9/5", label: "Average rating" },
  { value: "15 min", label: "To Gatwick terminals" },
  { value: "24/7", label: "Always available" },
];

export const HOW_IT_WORKS = [
  { step: "01", title: "Enter your trip info", desc: "Add your pick-up, destination, date, time, passengers and luggage. Instant availability for Gatwick, Heathrow or local Crawley journeys." },
  { step: "02", title: "Select a quote", desc: "View transparent, fixed-rate quotes with no hidden charges. Choose your vehicle — saloon, executive, MPV or wheelchair-accessible." },
  { step: "03", title: "Secure your booking", desc: "Pay by card, Apple Pay, Google Pay or cash. Get instant confirmation, driver details, real-time tracking and 24/7 support." },
];

export const FAQ = [
  { q: "How do I book a taxi with Clocktower Cars Gatwick?", a: "Book instantly online, call +44 1293 515151, or use our mobile app. You'll get instant fare quotes, confirmation and real-time driver updates — fast, secure and easy to re-book in seconds." },
  { q: "What are your rates for airport transfers and how are they calculated?", a: "Every airport transfer is a fixed, all-inclusive fare confirmed before you travel — no meter and no surge pricing. Prices are based on distance and vehicle class, with airport waiting time and flight tracking included." },
  { q: "Do you offer wheelchair-accessible taxis?", a: "Yes. We operate wheelchair-accessible vehicles with trained drivers, ramps and secure seating for daily journeys, appointments and accessible Gatwick Airport transfers." },
  { q: "What is your Meet and Greet airport service?", a: "With Meet and Greet, your driver waits in arrivals with a name board, helps with your bags and walks you to the car — ideal for families, groups and first-time visitors, even if your flight is early or late." },
  { q: "Are your drivers licensed and professionally trained?", a: "Every driver is fully licensed, DBS-checked and professionally trained to provide courteous, knowledgeable service and keep every customer safe and comfortable." },
  { q: "What payment methods do you accept?", a: "We accept card, bank transfer, Apple Pay, Google Pay and cash. Corporate account billing is also available for regular business travellers." },
];

export const ACCREDITATIONS = [
  { code: "ISO 9001", label: "Quality Management", desc: "Certified quality-management systems across every journey." },
  { code: "ISO 27001", label: "Information Security", desc: "Your booking and personal data are handled securely." },
  { code: "ISO 45001", label: "Health & Safety", desc: "Occupational health & safety built into how we operate." },
  { code: "Licensed", label: "Private Hire Operator", desc: "Fully licensed private hire operator with local authority." },
  { code: "DBS", label: "Checked Drivers", desc: "Every chauffeur is enhanced DBS background-checked." },
  { code: "PSV", label: "Fully Insured", desc: "Comprehensive public & passenger liability insurance." },
];

export const PATRONS = [
  { name: "NHS", logo: "/images/patrons/nhs.webp" },
  { name: "Pfizer", logo: "/images/patrons/pfizer.webp" },
  { name: "Royal Borough of Kingston upon Thames", logo: "/images/patrons/kingston.webp" },
  { name: "Kent County Council", logo: "/images/patrons/kent.webp" },
  { name: "Epsom & Ewell Borough Council", logo: "/images/patrons/epsom-ewell.webp" },
  { name: "Croydon Council", logo: "/images/patrons/croydon.webp" },
  { name: "London Borough of Sutton", logo: "/images/patrons/sutton.webp" },
  { name: "London Borough of Richmond", logo: "/images/patrons/richmond.webp" },
  { name: "London Borough of Hounslow", logo: "/images/patrons/hounslow.webp" },
  { name: "London Borough of Merton", logo: "/images/patrons/merton.webp" },
  { name: "NHS Epsom & St Helier University Hospitals", logo: "/images/patrons/nhs-epsom.webp" },
  { name: "ISS", logo: "/images/patrons/iss.webp" },
  { name: "Glyn School", logo: "/images/patrons/glyn-school.webp" },
  { name: "CMAC Group", logo: "/images/patrons/cmac.webp" },
  { name: "Surrey Chamber of Commerce", logo: "/images/patrons/surrey-chamber.png" },
  { name: "SME Surrey Business Awards 2023 — Silver Winner", logo: "/images/patrons/sme.jpg" },
];
